<!--
 * @Author: your name
 * @Date: 2021-03-23 11:23:32
 * @LastEditTime: 2021-03-27 10:26:02
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /zhulogic-design-cloud-next/src/components/dialogs/login.vue
-->
<template>
  <div>
    <Modal
      v-model="model"
      class-name="login-dialog-class"
      title=""
      :width="width"
      :closable="false"
      @on-ok="submitCoupon"
      @on-cancel="cancel"
      :footer="false"
      :draggable="false"
      footer-hide
    >
      <div v-if="!showUrl" class="loading">
        <img src="../../images/new-global.gif" alt="" />
        <p>加载中...</p>
      </div>
      <div v-show="showUrl">
        <iframe
          v-if="model && iframeUrl"
          id="inlineFrame"
          title="住逻辑登录"
          width="100%"
          height="540px"
          frameborder="0"
          class="page-hide"
          :src="pathFix + iframeUrl"
        >
        </iframe>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'login-view',
  data() {
    return {
      model: false,
      width: 874,
      iframeUrl: '',
      showUrl: false,
    }
  },
  props: {
    pathFix: {
      type: String,
      default: '',
    },
  },
  methods: {
    open(redirect) {
      this.model = true
      this.iframeUrl = `/sign?redirect=${redirect}&dialog=true#next`
      setTimeout(() => {
        this.showUrl = true
      }, 1200)
    },
    submitCoupon() {
      this.model = false
      this.showUrl = false
    },
    cancel() {
      this.model = false
      this.showUrl = false
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/ .ivu-modal-wrap {
  .ivu-modal {
    height: 540px;
    border-radius: 4px;
    overflow: hidden;
  }
  .ivu-modal-body {
    padding: 0px;
  }
  .ivu-modal-content {
    height: 540px;
  }
}
.loading {
  width: 100%;
  text-align: center;
  & > img {
    width: 100px;
    margin-top: 180px;
  }
  & > p {
    font-size: 12px;
    margin-top: 20px;
    color: #666666;
  }
}
</style>
